import React, { useEffect } from "react";
import { Modal, Form, Input, message } from "antd";
import api from "../api";

const ProductorModal = ({ open, onCancel, onSuccess, record }) => {
  const [form] = Form.useForm();
  const isEditing = !!record;

  useEffect(() => {
    if (open && record) {
      form.setFieldsValue({
        identificacion: record.identificacion,
        nombre: record.nombre,
        mail: record.mail,
        whatsapp: record.whatsapp,
        observaciones: record.observaciones,
      });
    } else if (open) {
      form.resetFields();
    }
  }, [open, record, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (isEditing) {
        // According to user request, the ID field might be idproveedores
        const id = record.idproveedores || record.id || record.idproveedor;
        await api.put(`/productor/${id}`, values);
        message.success("Productor actualizado correctamente");
      } else {
        await api.post("/productor/", values);
        message.success("Productor creado correctamente");
      }
      form.resetFields();
      onSuccess();
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        message.error(error.response.data.message);
      } else {
        message.error(isEditing ? "Error al actualizar productor" : "Error al crear productor");
      }
    }
  };

  return (
    <Modal
      title={isEditing ? "Editar Productor" : "Nuevo Productor"}
      open={open}
      onCancel={onCancel}
      onOk={handleOk}
      okText={isEditing ? "Actualizar" : "Guardar"}
      cancelText="Cancelar"
    >
      <Form form={form} layout="vertical">
        <Form.Item name="identificacion" label="Identificación" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="nombre" label="Nombre" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="mail" label="Correo">
          <Input type="email" />
        </Form.Item>
        <Form.Item
          name="whatsapp"
          label="WhatsApp"
          extra="Ingresa el número como 5939999... Si son varios, sepáralos con comas. Ej: 5931234567,5939876543"
          rules={[
            {
              validator: (_, value) => {
                if (!value) return Promise.resolve();
                const valid = value.split(",").every((n) => /^\d+$/.test(n.trim()) && n.trim().length > 0);
                return valid
                  ? Promise.resolve()
                  : Promise.reject("Solo números separados por comas. Ej: 5931234567,5939876543");
              },
            },
          ]}
        >
          <Input
            onChange={(e) => {
              const cleaned = e.target.value.replace(/[^\d,]/g, "");
              form.setFieldValue("whatsapp", cleaned);
            }}
            placeholder="5931234567 o 5931234567,5939876543"
          />
        </Form.Item>
        <Form.Item name="observaciones" label="Observaciones">
          <Input.TextArea rows={3} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ProductorModal;
